import { useState } from "react";
import { Alert } from "../../theme/Component/Alert";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _BusinessProcess, _single } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import { BasicButton } from "../../theme/Component/BasicButton";
import { SelectBPMRequestProcedureByAccount } from "./SelectBPMRequestProcedureByAccount";
import { PrintJson } from "../../theme/Component/PrintJson";

interface Props {
    updateFather?: Function;
    addPropsInit?: Record<string, any>;
}

export const BPMRequestProcedureType = ({ updateFather, addPropsInit }: Props) => {


    const [indexTap, setIndexTap] = useState(0);
    const [obs, setObs] = useState<string>("");
    const [procedure, setProcedure] = useState<any>({});

    const _bProcess = useDataBean(_BusinessProcess)

    const startProcess = () => {
        const Props = {
            FromDate: _single.getCurrenDate(),
            User: _single.getAccountID(),
            ...(addPropsInit ? { ...addPropsInit } : {})
        };
        _bProcess.instance.requestBusinessProcess(_single.getAccountID(), obs, procedure.CodeProcess, "IDAccount", _single.getAccountID(), JSON.stringify(Props), "").then(
            (resp) => {
                setIndexTap(1)
                _bProcess.setBean(resp)
                updateFather?.()
            }
        ).catch(
            err => {

                toast.success("No se pudo iniciar la soliciud")
            }
        )
    }

    return (
        <div className="row">
            {indexTap === 0 &&
                <>
                    <div className="col-md-12">
                        <SelectBPMRequestProcedureByAccount _ConfigOptions={{ returnType: "Object" }} idSelector={procedure.IDRequestTypeBpm} onChange={(e) => { setProcedure(e) }} />
                    </div>
                    <div className="col-md-12">
                        <label>Justificación de la Solictiud</label>
                        <textarea className="form-control" value={obs} onChange={(e) => { setObs(e.target.value) }}></textarea>
                    </div>
                    <div className="col-md-12 mt-4">
                        <BasicButton disable={!procedure.Code} eventClick={() => {
                            if (obs.length > 15) {
                                startProcess()
                            } else {
                                toast.error("La justificación de la solicitud debe tener minimo 15 caracteres")
                            }
                        }} icon="ri-save-line" children={`Solicitar ${procedure.Name ?? "Tramite"}`} />
                    </div>
                </>

            }
            {indexTap === 1 &&
                <div className="col-md-12">
                    {/* <PrintJson json={_bProcess.bean} /> */}
                    <Alert clase='success'>
                        <strong>Se ha radicado un trámite</strong>
                        <p>
                            <b># </b>{_bProcess.bean.AlphaCode} <br />
                            por favor de seguimiento en su <a >Bandeja Personal</a>.
                        </p>
                    </Alert>
                </div>
            }
        </div>
    )
}